import { SUPPORTED_TOKENS, TRANSACTION_EXPLORER_LINK, TRANSACTION_STATES } from 'src/utils/constants';
import { timestampToFormattedDate } from 'src/utils/dates';
import emptyTransactionsListIllustration from 'src/icons/desk-btc-illustration.svg';
import ExternalLinkIcon from 'src/icons/externalLink';
import { copyToClipboard, removeTrailingZeros, truncate } from 'src/utils/strings';

const LargeTransactionTable = ({ transactions, accounts, className, screenWidth }) => (
    <>
        <table className={'w-full mt-6' + (className ?? '')}>
            <tbody>
                {transactions.map((transaction, i) => {
                    const token = transaction.tokenSymbol ?? SUPPORTED_TOKENS[transaction.network][0];
                    const side =
                        transaction.from.toLowerCase() === accounts[transaction.network].toLowerCase() ? '-' : '+';
                    return (
                        <tr key={i} className={i !== transactions.length - 1 ? 'border-b border-gray-dark' : ''}>
                            <td className="py-4" title={transaction.status}>
                                <div
                                    className={`h-2 w-2 ${
                                        transaction.status === TRANSACTION_STATES.COMPLETED
                                            ? 'bg-green'
                                            : transaction.status === 'pending'
                                            ? 'bg-orange'
                                            : 'bg-red'
                                    } rounded-full mr-2`}
                                ></div>
                            </td>
                            <td className="py-4">
                                {transaction.time ? timestampToFormattedDate(transaction.time, screenWidth > 1024) : ''}
                            </td>
                            <td className="py-4" title={transaction.from}>
                                {side}
                                {removeTrailingZeros(parseFloat(transaction.amount).toFixed(8))}
                                <img
                                    src={`/crypto-icons/${token}.svg`}
                                    alt={`${token} icon`}
                                    width={20}
                                    className="mx-1 inline-block"
                                />
                                {token}
                            </td>
                            <td
                                className="py-4 cursor-pointer"
                                title={side === '+' ? transaction.from : transaction.to}
                                onClick={() => copyToClipboard(side === '+' ? transaction.from : transaction.to)}
                            >
                                {side === '+'
                                    ? `from ${truncate(transaction.from, 10)}`
                                    : `to ${truncate(transaction.to, 10)}`}
                            </td>
                            <td className="py-4">{transaction.network} Network</td>
                            <td className="py-4">
                                <a
                                    href={`${TRANSACTION_EXPLORER_LINK[transaction.network]}${transaction.id}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-gray-darker flex items-center"
                                >
                                    <ExternalLinkIcon className="ml-1 w-5" />
                                </a>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
        {transactions.length === 0 && (
            <div className="w-full flex flex-col items-center mt-10">
                <span className="font-bold">You don't have any transactions yet</span>
                <img src={emptyTransactionsListIllustration} alt="empty transactions list" className="w-1/3" />
            </div>
        )}
    </>
);

export default LargeTransactionTable;
